import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';

// Per-account results of the last dispatched order (exec price + slippage).
export default function LastResultsCard({ lastResults, accounts, isAr }) {
  if (!lastResults) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-2xl border border-white/10 bg-white/[0.02] p-4"
      data-testid="manual-last-results"
    >
      <h3 className="text-sm font-bold text-white/80 mb-3 flex items-center justify-between">
        <span>
          {isAr ? 'نتائج آخر أمر' : 'Last order results'}
          <span className="ml-2 text-xs text-white/50">
            ({lastResults.successes} ✓ · {lastResults.failures} ✗)
          </span>
        </span>
        {lastResults.reference_price != null && (
          <span className="text-[10px] text-white/50 font-normal">
            {isAr ? 'السعر المرجعي:' : 'Reference:'}{' '}
            <span className="text-white/80 font-mono">{Number(lastResults.reference_price).toFixed(5)}</span>
          </span>
        )}
      </h3>
      <div className="space-y-1.5">
        {lastResults.results?.map((r, i) => {
          const acc = accounts.find((a) => a.id === r.account_id);
          return (
            <div
              key={i}
              className={`px-3 py-2 rounded-lg text-xs border ${
                r.success ? 'bg-emerald-500/5 border-emerald-500/20' : 'bg-red-500/5 border-red-500/20'
              }`}
              data-testid={`order-result-${r.account_id}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 min-w-0">
                  {r.success ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 shrink-0" /> : <XCircle className="h-3.5 w-3.5 text-red-400 shrink-0" />}
                  <span className="truncate font-bold">{acc?.label || r.account_id}</span>
                  {r.order_id && <span className="text-[10px] text-white/40 font-mono">#{r.order_id}</span>}
                </div>
                {!r.success && (
                  <span className="text-[11px] text-red-300 truncate max-w-[60%]">{r.error || 'Failed'}</span>
                )}
              </div>
              {r.success && r.executed_price != null && (
                <div className="flex items-center gap-4 mt-1.5 text-[10px] pl-5.5">
                  <span className="text-white/50">
                    {isAr ? 'التنفيذ:' : 'Exec:'}{' '}
                    <span className="text-emerald-300 font-mono">{Number(r.executed_price).toFixed(5)}</span>
                  </span>
                  {r.slippage != null && (
                    <span className="text-white/50">
                      {isAr ? 'الانزلاق:' : 'Slippage:'}{' '}
                      <span className={`font-mono ${Math.abs(r.slippage) < 0.0001 ? 'text-emerald-300' : Math.abs(r.slippage) < 0.001 ? 'text-amber-300' : 'text-red-300'}`}>
                        {r.slippage > 0 ? '+' : ''}{Number(r.slippage).toFixed(5)}
                      </span>
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
